var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sl-container" }, [
    _vm.serviceLines
      ? _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", [
              _c(
                "button",
                {
                  ref: "navbarToggler",
                  staticClass:
                    "navbar-toggler mb-2 mt-2 toggle-sl-button d-block d-sm-block d-md-none",
                  attrs: {
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#navbarNav",
                    "aria-controls": "navbarNav",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation"
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/image/hamburger_menu_icon.svg")
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass:
                    "navbar navbar-expand-md navbar-light sl-navbar p-0 justify-content-center justify-content-md-start"
                },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "collapse navbar-collapse",
                        attrs: { id: "navbarNav" }
                      },
                      [
                        _c(
                          "ul",
                          { staticClass: "navbar-nav nav-fill w-100" },
                          [
                            _vm._l(_vm.displayedServiceLines, function(sl) {
                              return _c(
                                "li",
                                {
                                  key: sl.id,
                                  staticClass: "nav-item sl-nav-item"
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "nav-link",
                                      class: [
                                        sl.id === _vm.currentServiceLine.id
                                          ? "router-link-active"
                                          : ""
                                      ],
                                      attrs: {
                                        to:
                                          "/" +
                                          _vm.platformCategory +
                                          "/categories/" +
                                          sl.id
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.clickSLRoute(sl)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "p-3" }, [
                                        _vm._v(
                                          _vm._s(sl.name) +
                                            " (" +
                                            _vm._s(sl.services.length) +
                                            ")"
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.isMoreVisible
                              ? _c(
                                  "li",
                                  {
                                    staticClass:
                                      "nav-item sl-more-nav-item dropdown text-md-left text-center pl-md-5"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "nav-link nav-item-dropdown m-3",
                                        attrs: {
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "sub-dropdown" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.moreSize) + " more"
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "category-drop-down-arrow down ml-3 sub-dropdown"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dropdown-menu ml-md-4 container-fluid category-container more-dropdown-menu",
                                        attrs: {
                                          "aria-labelledby":
                                            "dropdownMenuButton"
                                        }
                                      },
                                      _vm._l(_vm.serviceLines, function(sl) {
                                        return _c(
                                          "div",
                                          { key: sl.id },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "dropdown-item serviceline-dropdown-item",
                                                class: [
                                                  sl.id ===
                                                  _vm.currentServiceLine.id
                                                    ? "router-link-active"
                                                    : ""
                                                ],
                                                attrs: {
                                                  to:
                                                    "/" +
                                                    _vm.platformCategory +
                                                    "/categories/" +
                                                    sl.id
                                                },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.clickMoreSLRoute(
                                                      sl
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(sl.name))]
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89d6f1ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89d6f1ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/DisplaySubCategories.vue
// module id = null
// module chunks = 